<template>
    <p class="theButton  click" :class="{margin, cancel}"><slot></slot></p>
    
    <!-- 
     <SimpleButton cancel margin>Nice</SimpleButton> 
     -->
</template>
<script>
  export default {
      data() {return {}},
      props:{
        margin: Boolean,
        cancel: Boolean,
      }
  }
</script>

<style scoped>
.theButton {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    padding: 7px 40px 8px;
    cursor: default;
    user-select: none;    
    border-radius: var(--buttonRadius);
    border-radius: 0;
    background-color: var(--buttonBack);
    color: var(--buttonColor);
    border: var(--buttonBorder);
    /* border-top: var(--buttonBorderTop);   */

}

.margin{
  margin-left: 6px;
  margin-right: 6px;
}

.cancel{
  padding: 7px 36px 8px;
  font-weight: 400;
  border-radius: var(--buttonCancelRadius);
  border-radius: 0;
    background-color: var(--buttonCancelBack);
    /* background-color: white; */
    color: var(--buttonCancelColor);
    /* border-top: var(--buttonCancelBorder);   */
    border: var(--buttonCancelBorder);
}
.cancel:hover{
    /* background-color: var(--buttonCancelBack); */
    /* background-color: rgba(235, 235, 235, 0.5); */
    /* color: var(--buttonCancelColor); */
    /* border-top: var(--buttonCancelBorder);   */
    /* border: var(--buttonCancelBorder); */
}

</style>